export const LM_MODULES = ['delivery_condition', 'return_condition'];

export const isSubFolders = (moduleName) => LM_MODULES.includes(moduleName);
